<template>
  <div class="centerdiv">
    <h2>用户出题列表</h2>
    <prepare-problem-table-user :tableData="dshProblemListUser" ></prepare-problem-table-user>
  </div>
</template>

<script>
  import prepareProblemTableUser from '@/components/prepareProblemTableUser/prepareProblemTableUser'
  import { getSubmitProblemList } from '@/api/api_prepareProblemUser.js'
  export default {
    data () {
      return {
        value: '',
        dshProblemListUser: ''
      }
    },
    computed: {

    },
    created () {
      console.log('----取未审核过的用户出的题----')
      getSubmitProblemList(0).then((res) => {
        let data = res.data
        console.log('----data=----' + JSON.stringify(data))
        if (data.isOk) {
          this.dshProblemListUser = data.data
        }
        console.log('----this.dshProblemListUser=----' + JSON.stringify(this.dshProblemListUser))
      }).catch((err) => {
        this.showMsg(err)
        this.loading = false
      })
    },
    mounted () {

    },
    components: {
      prepareProblemTableUser
    },
    methods: {

    }
  }
</script>

<style scoped>
  .centerdiv{
    height: auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// prepareProblemListUser.vue?e7516cb8